import $ from 'jquery';
import bodyScroll from '../scripts/bodyScroll';
import breakpoint from '../scripts/breakpoint';
import shared from '../scripts/shared';

$.addInit(function(context){
	var base = '.b-head';
	$(base, context).each(function(){
		var component = $(this);
		var humburger = component.find('.b-humburger');
		var menuWrap = component.find(base + '-nav');
		var menu = component.find('.b-menu');
		var isActive = false;

		function toggleMenu() {
			isActive = !isActive;

			humburger.toggleClass('m-active');
			component.toggleClass('m-active');

			if (isActive) {
				document.querySelector('body').style.overflow = 'hidden';
				// bodyScroll.disable(menu.get(0), {reserveScrollBarGap: true});
			} else {
				document.querySelector('body').style.overflow = 'auto';
				// bodyScroll.enable(menu.get(0));
			}
		}

		breakpoint(null, 'lg')
			.onmatch(function(){
				humburger.on('click', toggleMenu);
			})
			.onmismatch(function() {
				humburger.off('click', toggleMenu);
			});

		shared.headerHeight = component.height();
	});
});
